module.exports = __webpack_public_path__ + "img/avatar-default.e47cc635.jpg";